import StatusDetailModal from './components/StatusDetailModal'

export default {
  statusDetail: StatusDetailModal
}
